export default __webpack_public_path__ + "assets/vimeo.bbf95529.svg";